import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import moment from "moment";
import ReactGA from "react-ga4";
import { Form, Button } from "antd";
import _, { isArray } from "lodash";

import { qsList } from "./../../constants/demoQuestionList";
// import { qsList } from "../../constants/testQuestionList";
import ProgressBar from "./progressBar";
import SingleSelectQuestionList from "../questionTypes/singleSelectOptions";
import MultiSelectQuestion from "../questionTypes/multiSelectOptions";
import CompletedMessage from "../pagesWithoutQuestions/questionaireCompleted";
import QuestionRoadblock from "./../pagesWithoutQuestions/questionRoadblock";
import PersonalInformation from "../questionTypes/personalInformation";
import PhotoUpload from "../questionTypes/photoUpload";
import SingleInput from "../questionTypes/singleInput";
import RoutineQuestion from "../questionTypes/routineQuestions";
import LimitedMultipleOptions from "../questionTypes/limitedMultipleOptions";
import SingleQuestionWithJumpQuestion from "../questionTypes/singleSelectWithJumpQuestion";
import JumpMultipleSelectQuestion from "../questionTypes/jumpMultiSelectQuestion";
import ExtraInformationTextArea from "../questionTypes/extraInformationTextarea";
import MultipleOptionsWithInput from "../questionTypes/multipleOptionWithInput";
import SingleSelectWithInput from "../questionTypes/singleSelectWithInput";
import AppLogo from "../common/appLogo";
import MultipleWithImage from "../questionTypes/multipleWithImage";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { createSurveyApi } from "../../services/survey.service";
import MultiSelectCheckboxGroup from "../questionTypes/multiSelectCheckboxGroup";
import MultiSelectRadioGroup from "../questionTypes/multiSelectRadioGroup";
import { homeBaseUrl } from "../../constants/url";
import SkinConcernType from "../questionTypes/skinConcernType";
import thumbnail from "./../../assets/images/thumbnail.png";
import StartQuiz from "../pagesWithoutQuestions/StartQuiz";

interface props {
  setFinalFormValue?: any;
  surveyId?: any;
  userData?: any;
}

const QuestionaireComponent: React.FC<props> = (props) => {
  const { userData } = props;
  const [previousInfo, setPreviousInfo] = useState(userData?.user_information);
  const [currentQuestion, setCurrentQuestion] = useState<any>({});
  const [activeQustionNumber, setActiveQuestionNumber] = useState(0);
  const [submitedValues, setSubmittedValues] = useState<any>([]);
  const [submitProductValues, setsubmitProductValues] = useState<any>([]);
  const [totalQuestions, setTotalQuestions] = useState<number>(0);
  const [jumpQuestion, setJumpQuestion] = useState<boolean>(false);
  const [skinSensitivity, setskinSensitivity] = useState<String>("");
  const [checkboxVisible, setCheckboxVisible] = useState(false);
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [routineProductError, setRoutineProductError] = useState(false);
  const [discardProductError, setDiscardProductError] = useState(false);
  const [currentRoutineProduct, setCurrentRoutineProduct] = useState([]);
  // const [routineOriginalProducts, setRoutineOriginalProducts] = useState([]);
  const [discardProduct, setDiscardProduct] = useState([]);
  const [keepUsingRoutineProduct, setKeepUsingRoutineProduct] = useState();
  const [rawKeepUsingRoutineProducts, setRawKeepUsingRoutineProducts] =
    useState();
  const [startTime, setStartTime] = useState(
    moment().format("YYYY-MM-DD hh:mm:ss")
  );
  const [submissionErrors, setSubmissionErrors] = useState();
  const [emailExists, setEmailExists] = useState(false);
  const location = useLocation();
  const { r, winner_token } = Object.fromEntries(
    new URLSearchParams(location.search)
  );
  const [suggestionsData, setSuggestions] = useState<any>();
  const [productPriceRanges, setProductPriceRanges] = useState();
  const [subSelection, setSubSelection] = useState<any>();
  const userEmail = localStorage.getItem("user_email");
  const surveyId = localStorage.getItem("survey_id");

  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  useEffect(() => {
    setCurrentQuestion(qsList[activeQustionNumber]);
    setTotalQuestions(qsList.length);
  }, []);

  // useEffect(() => {
  //   setPreviousInfo(userData?.user_information);
  // }, [userData]);

  // useEffect(() => {
  //   console.log("userEmail", userEmail);
  //   if (userEmail) {
  //     setPreviousInfo((prev: any) => ({
  //       ...prev,
  //       email: userEmail,
  //     }));
  //   }
  // }, [userEmail]);

  const isSelectedProduct =
    currentQuestion?.question ===
    "Where do you like to shop your new skincare products?";

  useEffect(() => {
    setCurrentQuestion(qsList[activeQustionNumber]);
    // if (qsList.length === activeQustionNumber) {
    //   postFormValues();
    // }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [activeQustionNumber]);

  const handlePriceRangeChange = (ranges: any) => {
    setProductPriceRanges(ranges);
  };

  const renderCurrentQuestion = (form?: any) => {
    switch (currentQuestion?.type) {
      case "landing":
        return (
          <StartQuiz
            setActiveQuestionNumber={setActiveQuestionNumber}
            activeQustionNumber={activeQustionNumber}
          />
        );
      case "single":
        return <SingleSelectQuestionList activeQuestion={currentQuestion} />;

      case "single with number":
        return (
          <SingleQuestionWithJumpQuestion
            activeQuestion={currentQuestion}
            userValue={setskinSensitivity}
          />
        );

      case "multiple":
        return <MultiSelectQuestion activeQuestion={currentQuestion} />;

      case "multiple checkbox":
        return (
          <MultiSelectCheckboxGroup
            activeQuestion={currentQuestion}
            discardProducts={discardProduct}
          />
        );
      case "multiple radio":
        return (
          <MultiSelectRadioGroup
            activeQuestion={currentQuestion}
            suggestionsData={suggestionsData}
            handlePriceRangeChange={handlePriceRangeChange}
          />
        );

      case "multiple with image":
        return (
          <MultipleWithImage activeQuestion={currentQuestion} form={form} />
        );

      case "single input":
        return (
          <SingleInput
            placeholder={currentQuestion?.placeholder}
            name={currentQuestion?.name}
            validation={currentQuestion?.validation}
          />
        );

      case "multiple with input":
        return (
          <MultipleOptionsWithInput
            activeQuestion={currentQuestion}
            form={form}
          />
        );
      case "single option with input":
        return (
          <SingleSelectWithInput
            activeQuestion={currentQuestion}
            form={form}
            placeholder={currentQuestion?.placeholder}
            inputType={currentQuestion?.inputType}
            currentRoutine={currentRoutineProduct}
            setKeepUsing={setKeepUsingRoutineProduct}
            setRawKeepUsing={setRawKeepUsingRoutineProducts}
            keepUsingRoutineProduct={keepUsingRoutineProduct}
            checkboxVisible={checkboxVisible}
            setDiscardProductError={setDiscardProductError}
          />
        );

      case "limited multiple":
        return (
          <LimitedMultipleOptions
            activeQuestion={currentQuestion}
            form={form}
            subSelection={subSelection}
          />
        );

      case "skin concern type":
        return <SkinConcernType activeQuestion={currentQuestion} form={form} />;

      case "photo upload":
        return <PhotoUpload form={form} />;

      case "personal information":
        return (
          <PersonalInformation
            errors={submissionErrors}
            form={form}
            setEmailExists={setEmailExists}
            emailExists={emailExists}
            previousInfo={previousInfo}
          />
        );

      case "extra_information":
        return <ExtraInformationTextArea activeQuestion={currentQuestion} />;

      case "jumpMultiple":
        return <JumpMultipleSelectQuestion />;

      default:
    }
  };

  const postFormValues = () => {
    if (submitting) {
      return;
    }
    const answersExcludingPriceRange = submitedValues.filter((obj: any) => {
      for (const key in obj) {
        if (key.includes("priceRange")) {
          return false;
        }
      }
      return true;
    });

    let subObj = {
      survey_id: surveyId || null,
      question_answers: {
        question_answers: answersExcludingPriceRange,
        products: submitProductValues,
        price_ranges: productPriceRanges,
      },
      referral_code: r,
      winner_token: winner_token,
      start_time: startTime,
      end_time: moment().format("YYYY-MM-DD hh:mm:ss"),

      // _method: "PUT",
    };
    setSubmissionErrors(undefined);
    setSubmitting(true);
    setSubmissionErrors(undefined);
    // if (previousInfo?.can_revise) {
    //   dispatch(
    //     reviseSurveyApi({
    //       data: subObj,
    //       finalCallback: () => {
    //         setSubmitting(false);
    //       },
    //       successCallback: (res?: any) => {
    //         navigate(`/product-opinion?id=${res?.data?.id}`);
    //       },
    //       failureCallback: (errors: any) => {
    //         setSubmissionErrors(errors);
    //       },
    //     })
    //   );

    //   return;
    // }
    dispatch(
      createSurveyApi({
        data: subObj,
        finalCallback: () => {
          setSubmitting(false);
        },
        successCallback: (res: any) => {
          // navigate(`/product-opinion?id=${res?.data?.id}`);
          console.log("respnose", res);
          // navigate(res?.data?.response_url);
          window.location.href = res?.data?.response_url;
        },
        failureCallback: (errors: any) => {
          setSubmissionErrors(errors);
        },
      })
    );
  };

  const handleFormSubmission = (formValues: any) => {
    console.log("FormValues", formValues);
    if (isSelectedProduct) {
      setSubSelection(
        formValues["Where do you like to shop your new skincare products?"]
      );
    }
    let indexOfPIObject = _.findIndex(submitedValues, "first_name");
    if (indexOfPIObject > 0) {
      //for when there is an error on the personal information form
      submitedValues[indexOfPIObject] = formValues;
    } else {
      if (Object.keys(formValues)[0].includes("notLikeP-+-")) {
        Object.entries(formValues).forEach(([key, value]) => {
          if (!key.includes("notLikeP-+-")) {
            submitedValues.push(formValues);
          }
        });
      } else {
        submitedValues.push(formValues);
      }
    }
    // localStorage.setItem("formValues", JSON.stringify(submitedValues));
  };

  const handleRoutineAnswer = (values: any) => {
    let dayObj = _.pickBy(values, (value, key) => {
      return key[0] === "d";
    });
    let nightObj = _.pickBy(values, (value, key) => {
      return key[0] === "n";
    });
    let dayArray: any = [];
    let nightArray: any = [];
    Object.keys(dayObj).forEach(function (key, index) {
      if (dayObj[key]) {
        let name = dayObj[key]?.split("-+");
        dayArray.push({
          name: name[0],
          id: name[1] ?? null,
          category: key?.substr(4),
          keepUsing: true,
        });
      }
    });
    Object.keys(nightObj).forEach(function (key, index) {
      if (nightObj[key]) {
        let name = nightObj[key]?.split("-+");
        nightArray.push({
          name: name[0],
          id: name[1] ?? null,
          category: key?.substr(6),
          keepUsing: true,
        });
      }
    });
    let finalValues = {
      morning: dayArray,
      night: nightArray,
    };
    setsubmitProductValues(finalValues);
  };

  const handleFormSubmissionError = (error: any) => {
    console.log("error", error);
  };

  const handleBackAction = () => {
    console.log("skinSensitivity", skinSensitivity, currentQuestion);
    if (activeQustionNumber !== 0) {
      let qstnIndex = activeQustionNumber - 1;
      if (currentQuestion?.id === 18) {
        if (
          skinSensitivity === "Sometimes" ||
          skinSensitivity === "Often" ||
          skinSensitivity === "Most of the time"
        ) {
          console.log("ifRunning");
          qstnIndex = activeQustionNumber - 1;
        } else {
          console.log("elseRunning");
          qstnIndex = activeQustionNumber - 2;
        }
      } else {
        qstnIndex = activeQustionNumber - 1;
      }
      if (discardProduct.length === 0 && currentQuestion?.id === 11) {
        qstnIndex = activeQustionNumber - 2;
      }
      console.log("discardeded", discardProduct.length, currentQuestion);

      setCurrentQuestion(qsList[qstnIndex]);
      setActiveQuestionNumber(qstnIndex);

      let currentQuestionAfterBack = qsList[qstnIndex];

      if (currentQuestionAfterBack?.type !== "routine question") {
        submitedValues?.splice(-1);
      } else {
        submitProductValues?.splice(-1);
      }
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.replace(homeBaseUrl);
    // window.location.reload();
    // setActiveQuestionNumber(0)
    // setsubmitProductValues({})
    // navigate("/skincaresteps");
    // setPreviousInfo({})
  };

  const displayRequiredInfo = () => {
    const isCurrentQuestionSelectProductWithNumber =
      currentQuestion?.question === "Which skincare are you looking to buy?";
    const hideSubTitle =
      currentQuestion?.question ===
        "As the day goes by how does your skin feel?" ||
      currentQuestion?.question ===
        "On a scale of 1-5,where do you place your skin sensitivity?" ||
      currentQuestion?.question === "Which skincare you like to keep using?" ||
      currentQuestion?.question ===
        "How comfortable are you with exfoliating treatments like AHA, BHA, Retinol, Tretinoin?";
    if (currentQuestion?.required) {
      switch (currentQuestion?.required) {
        case "multiple":
          return (
            <p className="instruction">
              {currentQuestion?.instruction
                ? currentQuestion?.instruction
                : isCurrentQuestionSelectProductWithNumber
                ? "(Think of “Need” not want)"
                : "(Select all that apply)"}
            </p>
          );
        case "single":
          if (currentQuestion?.noInstruction) {
            return <></>;
          }
          return (
            !hideSubTitle && <p className="instruction">(Select only one)</p>
          );

        case "routine":
          return <></>;
      }
    }
  };

  const handleProductDiscardReason = (values?: any) => {
    let subProd: any = { ...submitProductValues };
    Object.keys(values).forEach((val?: any) => {
      let splitted = val?.split("-+-");
      subProd?.morning?.forEach((morn: any, mornIndex: number) => {
        if (morn?.name === splitted[1]) {
          morn = {
            ...morn,
            keepUsing: false,
            reason: values[val],
          };
          subProd.morning[mornIndex] = morn;
        }
      });
      subProd?.night?.forEach((nightItem: any, nightItemIndex: number) => {
        if (nightItem?.name === splitted[1]) {
          nightItem = {
            ...nightItem,
            keepUsing: false,
            reason: values[val],
          };
          subProd.night[nightItemIndex] = nightItem;
        }
      });
    });
    setsubmitProductValues(subProd);
  };

  return (
    <>
      {currentQuestion?.type === "roadblock" ? (
        <QuestionRoadblock
          title={currentQuestion?.data?.label}
          activeQustionNumber={activeQustionNumber}
          setActiveQuestionNumber={setActiveQuestionNumber}
          roadType={currentQuestion?.roadblockType}
        />
      ) : (
        <>
          {submitting ? (
            <CompletedMessage />
          ) : (
            <div
              className={`questionare-wrapper ${
                currentQuestion?.type === "landing"
                  ? "questionare-wrapper--landing"
                  : ""
              }`}
            >
              <ProgressBar
                totalQuestions={totalQuestions}
                answeredQuestions={activeQustionNumber}
              />
              <div
                className={`${
                  currentQuestion?.type === "limited multiple" ||
                  currentQuestion?.type === "skin concern type"
                    ? "active-question--limited"
                    : ""
                } ${
                  currentQuestion?.type === "multiple checkbox"
                    ? "active-question--checkbox-group"
                    : null
                } active-question`}
              >
                {activeQustionNumber >= 1 &&
                qsList.length - 1 !== activeQustionNumber ? (
                  <div
                    className="btn-back"
                    onClick={() => {
                      ReactGA.event({
                        category: "Quiz",
                        action: `Back button clicked`,
                        label: "",
                        nonInteraction: true, // optional, true/false
                        transport: "xhr",
                      });
                      handleBackAction();
                    }}
                  >
                    <MdArrowBack />
                  </div>
                ) : (
                  ""
                )}
                {currentQuestion?.hasVideoPlayback ? (
                  <>
                    {/* <iframe
                      width="500"
                      height="281"
                      src="https://www.youtube.com/embed/75D9V-On9RE?si=CMwd3FNdAeWEMxya&controls=1&modestbranding=1&showinfo=0&rel=0&autohide=1&disablekb=1"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="YouTube video"
                      className="video"
                    /> */}
                    <video
                      controls
                      width="500"
                      height="300"
                      className="video"
                      poster={thumbnail}
                    >
                      <source
                        src="https://missingskincare.com/wp-content/uploads/2024/08/Skin-quiz-Video-website.mp4"
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </>
                ) : (
                  <>
                    {!jumpQuestion ? (
                      <h2>
                        {currentQuestion?.data?.question ??
                          currentQuestion?.question}
                      </h2>
                    ) : (
                      <>
                        <h2>What does your skin sensitivity look like? </h2>
                        <p className="instruction">(Select all that apply) </p>
                      </>
                    )}
                  </>
                )}
                {displayRequiredInfo()}
                {currentQuestion?.type === "photo upload" ? (
                  <p className="instruction">
                    (This is optional but recommended.)
                  </p>
                ) : (
                  <></>
                )}
                {currentQuestion?.type === "limited multiple" ? (
                  <p className="instruction">
                    (Select your 1st, 2nd, and 3rd choice)
                  </p>
                ) : (
                  <></>
                )}
                {currentQuestion?.type === "skin concern type" ? (
                  <p className="instruction">
                    {currentQuestion?.instruction ? (
                      currentQuestion?.instruction
                    ) : (
                      <>(Select your 1st, 2nd, and 3rd choice)</>
                    )}
                  </p>
                ) : (
                  <></>
                )}
                {currentQuestion?.type === "routine question" ? (
                  <p className="instruction">
                    (Share accurately as possible. Your routine will be build
                    based on this.)
                  </p>
                ) : (
                  <></>
                )}
                {currentQuestion?.type === "multiple checkbox" ? (
                  <p className="instruction">
                    (Select each button that applies)
                  </p>
                ) : null}
                {currentQuestion?.question ===
                  "What's your range for skincare products?" &&
                  currentQuestion?.type === "multiple radio" && (
                    <p className="instruction">(Select one box that applies)</p>
                  )}
                {currentQuestion?.type !== "routine question" ? (
                  // FOR PRODUCT(MORNING /NIGHT) SELECTION QUESTION ONLY
                  <Form
                    layout="vertical"
                    form={form}
                    onFinish={(values) => {
                      let nextQuestionIndex = activeQustionNumber + 1;
                      if (values[currentQuestion?.question] === "Other") {
                        setDiscardProductError(true);
                        return;
                      }
                      if (currentQuestion?.inputType === "select") {
                        setDiscardProductError(false);
                        let validationError = true;
                        Object.keys(values).map((val: any) => {
                          if (
                            !isArray(values[val]) &&
                            values[val] !== "I want to swap all of my skincare."
                          ) {
                            validationError = true;
                          } else {
                            validationError = false;
                          }
                        });
                        if (validationError) {
                          setDiscardProductError(true);
                          return;
                        }
                        console.log(
                          "values",
                          currentRoutineProduct,
                          rawKeepUsingRoutineProducts
                        );
                        const unlikedProduct = _.difference(
                          currentRoutineProduct,
                          rawKeepUsingRoutineProducts ?? []
                        );
                        setDiscardProduct(unlikedProduct);
                        if (unlikedProduct.length === 0) {
                          nextQuestionIndex = activeQustionNumber + 2;
                        }
                      }

                      if (currentQuestion?.type === "multiple with image") {
                        setSuggestions(values[currentQuestion?.data?.question]);
                      }
                      if (emailExists) {
                        return;
                      }

                      if (currentQuestion?.type === "single with number") {
                        if (
                          skinSensitivity === "Sometimes" ||
                          skinSensitivity === "Often" ||
                          skinSensitivity === "Most of the time"
                        ) {
                          nextQuestionIndex = activeQustionNumber + 1;
                        } else {
                          nextQuestionIndex = activeQustionNumber + 2;
                        }
                      }
                      if (currentQuestion?.type === "multiple checkbox") {
                        handleProductDiscardReason(values);
                      }
                      handleFormSubmission(values);
                      if (qsList.length - 1 === activeQustionNumber) {
                        postFormValues();
                        return;
                      }
                      setActiveQuestionNumber(nextQuestionIndex);
                    }}
                    initialValues={{
                      first_name: previousInfo?.first_name,
                      last_name: previousInfo?.last_name,
                      age: previousInfo?.age,
                      contact: previousInfo?.contact,
                      email: userEmail || previousInfo?.email,
                      user_hear_about: previousInfo?.user_hear_about,
                      client_occurrence: previousInfo?.client_occurrence,
                    }}
                    onFinishFailed={(error) => {
                      handleFormSubmissionError(error);
                    }}
                    className="form--questionaire"
                  >
                    {renderCurrentQuestion(form)}
                    {discardProductError ? (
                      <div className="routine-error">
                        <span className="error-message">
                          You have to select/enter atleast one product
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}
                    {currentQuestion?.type !== "landing" && (
                      <Button htmlType="submit" className="btn-primary">
                        {currentQuestion?.type === "personal information" ||
                        currentQuestion?.data?.question ===
                          "First, pick your skincare vibe:"
                          ? currentQuestion?.data?.question ===
                            "First, pick your skincare vibe:"
                            ? "Start My Free Skin Quiz"
                            : "Submit"
                          : "Next"}
                      </Button>
                    )}
                  </Form>
                ) : (
                  //FOR OTHER QUESTIONS
                  <Form
                    layout="vertical"
                    form={form}
                    onFinish={(values) => {
                      const routineValues: any = _.omitBy(values, _.isNil);
                      setCurrentRoutineProduct(
                        _.uniq(Object.values(routineValues))
                      );
                      // let newRoutineValues: any = {};
                      // for (let key in routineValues) {
                      //   // Split the value using the '-+' separator
                      //   let splitValues = routineValues[key].split("-+");
                      //   // Assign the first element of the split array to the key
                      //   newRoutineValues[key] = splitValues[0].trim(); // trim() removes extra whitespaces
                      // }
                      // setRoutineOriginalProducts(
                      //   _.uniq(Object.values(newRoutineValues))
                      // );
                      setRoutineProductError(false);
                      let validationError = true;
                      Object.keys(values).forEach((val?: any) => {
                        if (values[val]) {
                          validationError = false;
                        }
                      });

                      if (validationError) {
                        setRoutineProductError(true);
                        return;
                      }
                      handleRoutineAnswer(values);
                      setActiveQuestionNumber(activeQustionNumber + 1);
                    }}
                    onFinishFailed={(error) => {
                      handleFormSubmissionError(error);
                    }}
                    className="form--routine-question"
                  >
                    <RoutineQuestion
                      activeQuestion={currentQuestion}
                      formRef={form}
                      setRoutineProductError={setRoutineProductError}
                    />

                    {routineProductError ? (
                      <div className="routine-error">
                        <span className="error-message">
                          You have to fill atleast one box
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}
                    <Button htmlType="submit" className="btn-primary">
                      Next
                    </Button>
                  </Form>
                )}
              </div>
              <div className="questionare-wrapper__footer">
                <a
                  href="https://missingskincare.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <AppLogo color="#6489b1" />
                </a>
                {previousInfo?.email ? (
                  <Button
                    type="link"
                    className="logout"
                    onClick={() => {
                      ReactGA.event({
                        category: "Quiz",
                        action: `Log out clicked`,
                        label: "",
                        nonInteraction: true, // optional, true/false
                        transport: "xhr",
                      });
                      handleLogout();
                    }}
                  >
                    Logout
                  </Button>
                ) : (
                  <></>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default QuestionaireComponent;
